// Main App component with React Router
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import {
  LandingPage,
  SpreadSelectionPage,
  ThemeSelectionPage,
  SpreadLayoutPage,
  ResultPage,
  PaymentMockPage,
  WalletRechargePage,
  HistoryPage,
  NotFoundPage,
  ReadingLabIndexPage,
  ImmersiveReadingLabPage,
  RitualJourneyLabPage,
  ReaderStylesLabPage,
  InternalReviewLoginPage,
  LocalDevReadingsPage,
  AdminLayout,
  AdminOverviewPage,
  AdminReadingsPage,
  AdminReadingDetailPage,
  AdminUsersPage,
  AdminUserDetailPage,
  AdminCouponsPage,
  OriginsPage,
  ManifestoPage,
  ArchivesPage,
  CreditsPage,
  LegalPage,
  TermsPage,
  PrivacyPage,
  RefundPage,
  ContactPage,
  BusinessInfoPage,
} from './pages';
import {
  StitchSelection,
  StitchResult,
  StitchSummary
} from './pages/StitchPages';

import { PaymentCheckoutPage } from './pages/payment/PaymentCheckoutPage';
import { PaymentSuccessPage } from './pages/payment/PaymentSuccessPage';
import { PaymentFailPage } from './pages/payment/PaymentFailPage';

import CookieConsentBanner from './components/common/CookieConsentBanner';
import AnalyticsRouteTracker from './components/common/AnalyticsRouteTracker';
import GlobalSidebar from './components/layout/GlobalSidebar';
import GlobalFooter from './components/layout/GlobalFooter';

function AppShell() {
  const location = useLocation();
  const hideGlobalChromePatterns = [
    /^\/admin(?:\/|$)/,
    /^\/lab(?:\/|$)/,
    /^\/payment(?:\/|$)/,
    /^\/spread-layout(?:\/|$)/,
    /^\/result(?:\/|$)/,
    /^\/share(?:\/|$)/,
    /^\/dev(?:\/|$)/,
    /^\/stitch\/selection(?:\/|$)/,
  ];
  const hideGlobalChrome = hideGlobalChromePatterns.some((pattern) => pattern.test(location.pathname));
  const showCommerceFooterPatterns = [
    /^\/$/,
    /^\/spreads$/,
    /^\/themes(?:\/|$)/,
    /^\/history(?:\/|$)/,
  ];
  const showCommerceFooter = showCommerceFooterPatterns.some((pattern) => pattern.test(location.pathname));

  return (
    <div className="min-h-screen bg-[#120d0b]">
      <AnalyticsRouteTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/spreads" element={<SpreadSelectionPage />} />
        <Route path="/themes/:spread" element={<ThemeSelectionPage />} />
        <Route path="/themes" element={<ThemeSelectionPage />} />
        <Route path="/spread-layout/:id" element={<SpreadLayoutPage />} />
        <Route path="/result/:id/summary" element={<ResultPage />} />
        <Route path="/result/:id" element={<ResultPage />} />
        <Route path="/share/:token" element={<ResultPage />} />
        <Route path="/payment/mock" element={<PaymentMockPage />} />
        <Route path="/wallet/recharge" element={<WalletRechargePage />} />
        <Route path="/payment/checkout" element={<PaymentCheckoutPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/fail" element={<PaymentFailPage />} />

        <Route path="/history" element={<HistoryPage />} />
        <Route path="/internal-review-login" element={<InternalReviewLoginPage />} />
        {import.meta.env.DEV && <Route path="/dev/local" element={<LocalDevReadingsPage />} />}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverviewPage />} />
          <Route path="readings" element={<AdminReadingsPage />} />
          <Route path="readings/:id" element={<AdminReadingDetailPage />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="users/:id" element={<AdminUserDetailPage />} />
          <Route path="coupons" element={<AdminCouponsPage />} />
        </Route>
        <Route path="/lab" element={<ReadingLabIndexPage />} />
        <Route path="/lab/immersive-reading" element={<ImmersiveReadingLabPage />} />
        <Route path="/lab/ritual-journey" element={<RitualJourneyLabPage />} />
        <Route path="/lab/reader-styles" element={<ReaderStylesLabPage />} />
        <Route path="/origins" element={<OriginsPage />} />
        <Route path="/manifesto" element={<ManifestoPage />} />
        <Route path="/archives" element={<ArchivesPage />} />
        <Route path="/credits" element={<CreditsPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/refund" element={<RefundPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/business-info" element={<BusinessInfoPage />} />

        {/* Stitch Design Routes */}
        <Route path="/stitch/selection" element={<StitchSelection />} />
        <Route path="/stitch/result" element={<StitchResult />} />
        <Route path="/stitch/summary" element={<StitchSummary />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {!hideGlobalChrome && <GlobalSidebar />}
      {!hideGlobalChrome && <CookieConsentBanner />}
      {showCommerceFooter && <GlobalFooter />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
